import { CharacterAttack } from './CharacterAttack';

export class AttackCyborgSpecialStanding extends CharacterAttack {
  updateAttackCollider() {}

  _triggerAttackAnimation() {
    super._triggerAttackAnimation();

    (this.attackCollider.x = this.character.x + 375 * this.character.faceDirection),
      (this.attackCollider.y = this.character.y);
    this.attackCollider.setSize(0, 0);

    this.scene.tweens.add({
      targets: this.attackCollider,
      x: this.character.x + 175 * this.character.faceDirection,
      y: this.character.y - 150,
      width: 450,
      height: 150,
      duration: 100,
      delay: 550,
    });
  }
}
